import moment from 'moment';
import { format } from 'date-fns';

export function currency(value: any, d = ',', t = '.', precision = 2) {
    let v = value ? value : 0;
    let s = v < 0 ? '-' : '';
    let i = parseInt(Math.abs(v.toFixed(precision)) + '', 10) + '';
    let j = i.length > 3 ? i.length % 3 : 0;
    return s + (j ? i.substr(0, j) + t : '')
        + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t)
        + (precision ? d + Math.abs(v - parseInt(s + i, 10)).toFixed(precision).slice(precision) : '');
}

export function extendedDate(dt: Date | string | null, locale = null, nullValue = ''): string {
	if (!dt) { return nullValue }

	var date: Date = (dt instanceof Date) ? dt : new Date(dt);

	return format(date, 'iiii d MMMM yyyy', { locale });
}

export function dayName(dt: Date | string | null, locale = null, nullValue = ''): string {
	if (!dt) { return nullValue }

	var date: Date = (dt instanceof Date) ? dt : new Date(dt);

	return format(date, 'iiii', { locale });
}

export function monthName(dt: Date | string | null, locale = null, nullValue = ''): string {
	if (!dt) { return nullValue }

	var date: Date = (dt instanceof Date) ? dt : new Date(dt);

	return format(date, 'MMMM', { locale });
}

export function euroAmount(value: any, zeroReplacement = null) {
	let v = value;
	if (v == 0 && zeroReplacement) {
		return zeroReplacement;
    }
    else {
		return currency(value, '.', ',', 2) + ' €';
	}
}


export function dollarsAmount(value: any, zeroReplacement = null) {
	let v = value;
	if (v == 0 && zeroReplacement) {
		return zeroReplacement;
    }
    else {
		return currency(value, '.', ',', 2) + ' $';
	}
}

export function percent(value: any) {
    let precision = 2;
	let symbol = "%";
	let decimal = ",";
    let v = value ? value.toFixed(precision) : 0.00;
    return (v+"").replace('.', decimal)+symbol;
}

export function human(value: number) {
	if (value >= 1000000) {
		return Math.round(value / 1000000) + 'M';
    }
    else if (value >= 1000) {
		return Math.round(value / 1000) + 'k';
    }
    else {
		return value;
	}
}

export function isoDate(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("YYYY-MM-DD");
}

export function localizedDate(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("L");
}

export function localizedExtendedDate(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("LL");
}

export function localizedFullDate(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("dddd LL");
}

export function year(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("YYYY");
}

export function month(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("MM");
}

export function monthNameShort(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("MMM");
}

export function monthNameFull(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("MMMM");
}

export function day(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("DD");
}

export function dayNameShort(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("ddd");
}

export function dayNameFull(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("dddd");
}

export function timeShort(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("hh:mm");
}

export function timeFull(dt: moment.Moment | string | null, nullValue = ''): string {
	if (!dt) { return nullValue }

	if (!moment.isMoment(dt)) {
		dt = moment(dt);
	}
	return dt.format("hh:mm:ss");
}

export function ifEmpty(value: any, emptyResult: string): string {
	return isNullOrWhitespace(value) && emptyResult || value;
}

export function pnr(handle: string, partLen = 4) {
	handle = handle.toUpperCase();
    return handle.substr(0, partLen) + '-' + handle.substr(4, partLen);
}

export function isNullOrWhitespace(text: any): boolean {
	if (text) {
		return text.toString().trim() == '';
	}
	return true;
}

export function isNullOrTodo(text: any): boolean {
    if (text) {
        const s = text.toString().trim();
		return s == '' || s.startsWith('TODO');
	}
	return true;
}



export const filters = {
    currency,
    localizedDate,
    extendedDate,
    day,
	dayName,
	dayNameShort,
    monthName,
	euroAmount,
	dollarsAmount,
	percent,
	human,
	isoDate,
	localizedExtendedDate,
	localizedFullDate,
	year,
	month,
	monthNameShort,
	monthNameFull,
	dayNameFull,
	timeShort,
	timeFull,
	ifEmpty,
	pnr,

	// Utilities
	isNullOrWhitespace
}
